<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="dataset"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      fixed-header
      height="70vh"
      class="table"
      hide-default-footer
      mobile-breakpoint="0"
      :items-per-page="dataset.length"
    >
      <template v-slot:item.name="{ item }">
        <p class="text-sm font-weight-bold mt-4 mb-0">
          {{ item.name || "n/c" }}
        </p>
      </template>

      <template v-slot:item.city="{ item }">
        <div>
          <p class="text-sm text-secondary font-weight-bold mt-4 mb-0">
            {{ item.city }}
          </p>
          <p class="text-sm text-secondary">
            {{ item.address }}
          </p>
        </div>
      </template>

      <template v-slot:item.placesavailable="{ item }">
        <p class="text-sm text-secondary font-weight-bold mt-4 mb-0">
          {{ item.spots }}
        </p>
        <p class="text-sm text-secondary">
          {{ item.reservableSpots }} reservable{{
            item.reservableSpots > 1 ? "s" : ""
          }}
        </p>
      </template>
      <template v-slot:item.actions="{ item }">
        <p
          class="mt-4 p-0 text-blue"
          style="text-decoration: underline; cursor: pointer"
          @click="goToParkingDetails(item)"
        >
          Modifier
        </p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "ParkingTable",

  props: {
    dataset: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      sortBy: "name",
      sortDesc: false,
      headers: [
        {
          text: "Parking",
          value: "name",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Adresse",
          value: "city",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Nombre de place",
          value: "placesavailable",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Action",
          value: "actions",
          class: "text-secondary font-weight-bolder opacity-7",
        },
      ],
      parkings: [],
    };
  },

  methods: {
    goToParkingDetails(e) {
      this.$router.push(`/parkings/${e.id}`);
    },
  },
};
</script>

<style scoped></style>
